import ODataAdapter from '@bingads-webui/js-data-odata';

export const getJsDataExtension = ({ config, state }) => (edm) => {
  const { store } = edm.jsdata;

  store.registerAdapter('odata', new ODataAdapter({
    ajaxOptions: {
      path: 'HotelCenter/V1',
      host: config.get('odata.url'),
      oDataToken: config.get('odata.token'),
      loginType: config.get('odata.loginType'),
    },
    state,
  }), { default: true });
};
